import _ from 'lodash';
import { BaseController } from '../../../common/base/controller';

// Do not display categories with the following titles
// in the faq modal
const CategoryFilter = ['Für Zahlungspartner', 'Für Banken'];

class FaqController extends BaseController {
  constructor(controllerService, freshdeskFaqsService, $uibModalStack, $scope) {
    'ngInject';
    super({ controllerService, freshdeskFaqsService, $uibModalStack, $scope });
  }

  $onInit() {
    this.freshdeskFaqsService.getFaqs([80000314642]).then((result) => {
      this.activate(result.faqs);
    });
  }

  activate(faq) {
    this.displayCategories = this.categories = this.cleanCategories(faq.categories);
    this.titles = [];
    this.traverse(this.categories, ['folders', 'articles'], (e) => {
      if (e.title && !_.includes(this.titles, e.title)) {
        this.titles.push(e.title);
      }
    });
    this.resetSearch();
  }

  cleanCategories(categories) {
    return _.filter(categories, cat => CategoryFilter.indexOf(cat.name) === -1);
  }

  selectFromTypeahead(value) {
    this.search = value;
    this.searchChanged();
  }

  resetSearch() {
    this.search = '';
    this.searchChanged();
  }

  searchChanged() {
    if (this.search) {
      this.displayCategories = [this.getFiltered(angular.copy(this.categories))];
      this.traverse(this.displayCategories, ['folders', 'articles'], (e) => {
        e.open = true;
      });
    }
    else {
      this.displayCategories = this.categories;
    }
    this.selectCategory(this.displayCategories[0]);
  }

  traverse(array, traverseProperties, action) {
    let nextProp = traverseProperties[0];
    array.forEach(e => {
      action(e, nextProp);
      if (traverseProperties.length > 0 && angular.isArray(e[nextProp])) {
        this.traverse(e[nextProp], traverseProperties.slice(1), action);
      }
    });
  }

  toggle(e, $event) {
    $event.stopPropagation();
    e.open = !e.open;
  }

  selectCategory(cat, $event) {
    if ($event) {
      $event.stopPropagation();
    }
    this.selectedCategory = cat;
    if (this.selectedCategory && !this.selectedCategory.selectedFolder) {
      this.selectFolder(this.selectedCategory, this.selectedCategory.folders[0]);
    }
  }

  selectFolder(cat, fol, $event) {
    if ($event) {
      $event.stopPropagation();
    }
    cat.selectedFolder = fol;
  }

  getFiltered(array) {
    let filtered = {folders: [{articles: []}]};
    _.map(array, (category) => {
      _.map(category.folders, (folder) => {
        _.map(folder.articles, (article) => {
          if(this.containsSearch(article)){
            filtered.folders[0].articles.push(article);
          }
        });
      });
    });
    return filtered;
  }

  containsSearch(a) {
    let titleContains = a.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
    let descContains = a.description.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
    return titleContains || descContains;
  }

  getArrayKeys(e) {
    return _.map(e, (value, key) => {
      if (angular.isArray(value)) {
        return key;
      }
    }).filter(key => {
      return key != null;
    });
  }

  close() {
    this.$uibModalStack.dismissAll('close');
  }
}

export default FaqController;



// WEBPACK FOOTER //
// ./src/app/common/ui/faq/faq.controller.js